import { Component } from '@angular/core';
import { DataService } from '../app/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Busca Facturas';
  errMsg:string="";
  aux:any;

  constructor (private dataService: DataService){
  }


}
